<template>
  <div>
    <div>
      <v-text-field
        name="last_name"
        type="text"
        class="freePlanMail"
        label="姓*"
        required
        box
        id="last-name-input"
        :error-messages="lastNameErrors"
        v-model="lastName"
        @change="validateInput()"
      ></v-text-field>
    </div>
    <div>
      <v-text-field
        name="first_name"
        type="text"
        class="freePlanMail"
        label="名*"
        required
        box
        id="first-name-input"
        :error-messages="firstNameErrors"
        v-model="firstName"
        @change="validateInput()"
      ></v-text-field>
    </div>
    <v-layout row wrap btn-row text-xs-center>
      <v-flex xs8 md4 offset-md4 offset-xs2>
        <v-btn id='stripe-checkout' @click="disableButton(); redirectToStripe()">登録する</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { loadStripe } from '@stripe/stripe-js'
  import axios from 'axios'

  export default {
    props: [
      'stripeKey',
      'stripeProductId',
      'lastNameValue',
      'lastNameErrors',
      'firstNameValue',
      'firstNameErrors',
      'userId'
    ],

    data () {
      return {
        lastName: this.lastNameValue,
        firstName: this.firstNameValue,
        productId: this.stripeProductId,
        userId: this.userId,
        stripe: loadStripe(this.stripeKey)
      }
    },

    methods: {
      validateInput () {
        if (!this.lastName || !this.firstName) {
          document.getElementById('stripe-checkout').disabled = true
        } else {
          document.getElementById('stripe-checkout').disabled = false
        }
      },

      disableButton () {
        document.getElementById('stripe-checkout').disabled = true
      },

      redirectToStripe: async function () {
        if (!this.lastName || !this.firstName) {
          return false
        }

        const ses = await axios.get('/set-session', {
          params: {
            last_name: this.lastName,
            first_name: this.firstName
          }
        })

        const res = await axios.get('/api/create-personal-checkout-session', {
          params: {
            priceId: this.productId,
            userId: this.userId
          }
        }).then(async res => {
          const data = res.data

          if (res.status !== 200 || !data || data.error) {
            document.getElementById('stripe-checkout').disabled = false
            return false
          }

          const stripe = await loadStripe(this.stripeKey)

          stripe.redirectToCheckout({
            sessionId: data.sessionId
          })

        }).catch(res => {
          document.getElementById('stripe-checkout').disabled = false
          console.log(res)
        })
      },

      window:onload = function () {
        let lastName = document.getElementById('last-name-input')
        let firstName = document.getElementById('first-name-input')

        if (!lastName || !firstName) {
          return
        }

        if (!lastName.value || !firstName.value) {
          document.getElementById('stripe-checkout').disabled = true
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../sass/variables';

  #stripe-checkout {
    padding: 8px 16px;
    background: #2196f3;
    color: #fff !important;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    &:hover {
      opacity: .9;
    }
    &:disabled {
      background: #f5f5f5;
      color: rgba(0,0,0,.87) !important;
    }
  }

  #stripe-container {
    display: flex;
    align-items: center;
    .stripe-button-el {
      background: none;
      border: none;
      box-shadow: none;
      padding: 0;
      span {
        display: inline-block;
        background: #2196f3;
        color: #fff !important;
        width: 100%;
        height: 100%;
        padding: 8px 16px;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
        &:hover {
          opacity: .9;
        }
      }
    }
  }

  .stripe-button-el:disabled {
    span {
      background: gray !important;
    }
  }
</style>
